export const PSEUDO_LOCALE_CODE = 'pseudo';

export const FROM_NOW = 'FROM_NOW';
export const DATE_WITHOUT_YEAR = 'DATE_WITHOUT_YEAR';
export const DATE_MEDIUM_WITHOUT_YEAR = 'DATE_MEDIUM_WITHOUT_YEAR';
export const RELATIVE_DAY = 'RELATIVE_DAY';
